<script>
import NewsIndex from '../index.vue'
export default NewsIndex
</script>
